import React from "react";
import { useSearchParams } from "react-router-dom";
import { AdminTitle } from "@/admin/AdminLayout";
import { SeoSettings } from "@/admin/seo/SeoSettings";
import { SeoHealth } from "@/admin/seo/SeoHealth";
import { RedirectsAdmin } from "@/admin/seo/RedirectsAdmin";
import { BrokenLinks } from "@/admin/seo/BrokenLinks";

const TABS: [string, string][] = [["settings", "Search & sharing"], ["health", "Health check"], ["redirects", "Redirects"], ["broken", "Broken links"]];

export default function AdminSeo() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "settings";
  const go = (t: string, extra: Record<string, string> = {}) => setParams({ tab: t, ...extra });
  return (
    <div data-testid="admin-seo">
      <AdminTitle title="SEO & Redirects" sub="How your pages appear on Google and when shared, plus redirects for moved or broken addresses." />
      <div className="flex flex-wrap gap-6 border-b border-neutral-200 mb-8">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => go(k)} className={`eyebrow text-[10px] pb-3 -mb-px border-b transition-colors ${tab === k ? "border-neutral-900" : "border-transparent text-neutral-500 hover:text-neutral-900"}`} data-testid={`seo-tab-${k}`}>{l}</button>
        ))}
      </div>
      {tab === "settings" && <SeoSettings />}
      {tab === "health" && <SeoHealth />}
      {tab === "redirects" && <RedirectsAdmin prefillFrom={params.get("from") || ""} />}
      {tab === "broken" && <BrokenLinks />}
    </div>
  );
}
